import React, { useState, useEffect, useReducer } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
} from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { TableCustom } from "../../../components/table";
import { reducerRegister } from "../../../helpers/reducers";
import { getGroupByIdApi } from "../../../api/formsColaboradoresGroups";
import {
  createQuestionsApi,
  deleteQuestionsApi,
  getAllQuestionsApi,
  getQuestionsByIdApi,
  updateQuestionsApi,
} from "../../../api/formsColaboradoresQuestions";
const { Text } = Typography;

const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

const options_obrigatorio = [
  { value: 0, label: "Não" },
  { value: 1, label: "Sim" },
];

const options_tipo = [
  { value: 1, label: "Descritiva" },
  { value: 2, label: "Data" },
  { value: 3, label: "Objetiva" },
  { value: 4, label: "Multipla" },
];

const array_tipo = {
  ["1"]: "Descritiva",
  ["2"]: "Data",
  ["3"]: "Objetiva",
  ["4"]: "Multipla",
};

const rules = {
  descricao: [{ required: true, message: "Digite a descrição!" }],
  ordem: [{ required: true, message: "Digite a ordem!" }],
  tipo: [{ required: true, message: "Selecione o tipo!" }],
  obrigatorio: [{ required: true, message: "Selecione uma opção!" }],
  status: [{ required: true, message: "Selecione o status!" }],
};

export const FormulariosColaboradoresCadQuestoes = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const tipo = Form.useWatch("tipo", form);
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [idAlt, setIdAlt] = useState(0);
  const [grupo, setGrupo] = useState(null);
  const { id_cad_grupos, id_cad_formularios } = useParams();

  useEffect(() => {
    if (id_cad_grupos) {
      getAllQuestions(id_cad_grupos);
      getGroupById(id_cad_grupos);
    }
  }, [id_cad_grupos]);

  const getGroupById = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getGroupByIdApi(id);
      if (statusCode === 200) {
        if (!response.data) {
          navigate(`/formularios-colaboradores/formularios/grupos/${id_cad_formularios}`);
        }
        setGrupo(response.data);
      } else {
        message.error(response.message);
        navigate(`/formularios-colaboradores/formularios/grupos/${id_cad_formularios}`);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
      navigate(`/formularios-colaboradores/formularios/grupos/${id_cad_formularios}`);
    } finally {
      setLoading(false);
    }
  };

  const getAllQuestions = async (group_id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getAllQuestionsApi(group_id);
      if (statusCode === 200) {
        dispatch({ type: "LOAD", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const createQuestions = async (data) => {
    setLoading(true);
    try {
      const { statusCode, response } = await createQuestionsApi(data);
      if (statusCode === 200) {
        message.success("Registro cadastrado com sucesso!");
        setShowModal(false);
        resetForm();
        if (response?.data) dispatch({ type: "ADD", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const updateQuestions = async (data) => {
    setLoading(true);
    try {
      const { statusCode, response } = await updateQuestionsApi(data);
      if (statusCode === 200) {
        message.success("Registro alterado com sucesso!");
        setShowModal(false);
        resetForm();
        if (response?.data) dispatch({ type: "UPDATE", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const getQuestionsById = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getQuestionsByIdApi(id);
      if (statusCode === 200) {
        setShowModal(true);
        form.setFieldsValue({
          descricao: response?.data?.descricao,
          ordem: response?.data?.ordem,
          tipo: response?.data?.tipo,
          obrigatorio: response?.data?.obrigatorio,
          exige_pontuacao: response?.data?.exige_pontuacao,
          status: response?.data?.status,
        });
        setIdAlt(response.data.id);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const deleteQuestions = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await deleteQuestionsApi(id);
      if (statusCode === 200) {
        message.success("Registro deletado com sucesso!");
        dispatch({ type: "DELETE", payload: { id: id } });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
    },
    {
      title: "Ordem",
      dataIndex: "ordem",
    },
    {
      dataIndex: "tipo",
      title: "Tipo",
      render: (_, e) => array_tipo[e.tipo] ?? "",
      renderText: (e) => array_tipo[e.tipo] ?? "",
    },
    {
      dataIndex: "obrigatorio",
      title: "Obrigatório",
      render: (_, e) => (e.obrigatorio === 1 ? "Sim" : "Não"),
      renderText: (e) => (e.obrigatorio === 1 ? "Sim" : "Não"),
    },
    {
      dataIndex: "exige_pontuacao",
      title: "Exige Pontuação",
      render: (_, e) => (e.exige_pontuacao === 1 ? "Sim" : "Não"),
      renderText: (e) => (e.exige_pontuacao === 1 ? "Sim" : "Não"),
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      renderText: (e) => (e.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 150,
      sorter: false,
      render: (_, e) => (
        <Space.Compact>
          {[3, 4].includes(e.tipo) && (
            <Tooltip title="Alternativas">
              <Button
                loading={loading}
                onClick={() =>
                  navigate(
                    `/formularios-colaboradores/formularios/grupos/${id_cad_formularios}/questoes/${id_cad_grupos}/alternativas/${e.id}`
                  )
                }
                icon={<UnorderedListOutlined />}
              />
            </Tooltip>
          )}

          <Button loading={loading} onClick={() => getQuestionsById(e.id)} icon={<EditOutlined />} />
          <Button
            danger
            loading={loading}
            icon={<DeleteOutlined />}
            onClick={() => {
              modal.confirm({
                title: "Deseja deletar este registro?",
                okText: "Sim",
                cancelText: "Cancelar",
                onOk() {
                  deleteQuestions(e.id);
                },
              });
            }}
          />
        </Space.Compact>
      ),
    },
  ];

  const onSubmit = (formData) => {
    formData.id_cad_grupos = id_cad_grupos;
    if (idAlt > 0) {
      formData.id = idAlt;
      updateQuestions(formData);
    } else {
      createQuestions(formData);
    }
  };

  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Questão
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1200}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="descricao" label="Descrição" rules={rules.descricao}>
              <Input size="large" disabled={loading} placeholder="Informe a descrição" />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="ordem" label="Ordem" rules={rules.ordem}>
              <InputNumber
                className="full-width"
                size="large"
                controls={false}
                disabled={loading}
                placeholder="Informe a ordem"
                min={1}
                max={1000}
                step={1}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="tipo" label="Tipo" rules={rules.tipo}>
              <Select
                size="large"
                placeholder="Selecione o tipo"
                disabled={loading}
                style={{ width: "100%" }}
                options={options_tipo}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="obrigatorio" label="Obrigatório" rules={rules.obrigatorio}>
              <Select
                size="large"
                placeholder="Selecione uma opção"
                disabled={loading}
                style={{ width: "100%" }}
                options={options_obrigatorio}
              />
            </Form.Item>
          </Col>

          {tipo === 3 && (
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="exige_pontuacao" label="Exige Pontuação" rules={rules.obrigatorio}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_obrigatorio}
                />
              </Form.Item>
            </Col>
          )}

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="status" label="Status" rules={rules.status}>
              <Select
                size="large"
                placeholder="Selecione o status"
                disabled={loading}
                style={{ width: "100%" }}
                options={options_status}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Formulários Colaboradores"
              onClickBack={() => navigate(`/formularios-colaboradores/formularios/grupos/${id_cad_formularios}`)}
            />
            <HeaderTitle
              title={["Formulários", "Grupos", "Questões"]}
              subtitle={`Grupo - ${grupo?.descricao ?? ""}`}
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
